import React, { useState } from 'react';
import camelCaseRecursive from 'camelcase-keys-recursive';
import snakeCaseKeys from 'snakecase-keys';
import { Col, Modal, Row } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { DatatableEmployeeName, DefaultModal, Reminder } from '../../../components';
import ApproveRejectStyledActions from '../../../components/DatatableActions/ApproveRejectStyledActions';
import OtherRequestForm from './OtherRequestForm';
import { approveOtherRequestRequest, deleteOtherRequestRequest, rejectOtherRequestRequest } from '../../../requests/otherRequests';
import { sendAlert } from '../../../actions/utils';
import OtherRequestRejectForm from './OtherRequestRejectForm';
import ApprovementStatusStyled from '../../../components/DatatableColumns/ApprovementStatusStyled';

const OtherRequestInfoTable = props => {
  const { currentEmployee, item, moreData, setModalShow, setMoreData } = props;

  const {
    createdAt,
    startDate,
    endDate,
    otherRequestTypeName,
    reason,
    additional,
    status,
    translatedStatus
  } = camelCaseRecursive(item);
  const dispatch = useDispatch();
  const [defaultModalBody, setDefaultModalBody] = useState('');
  const [defaultModalShow, setDefaultModalShow] = useState(false);
  const [defaultModalButtons, setDefaultModalButtons] = useState(true);
  const [defaultModalTitle, setDefaultModalTitle] = useState('');
  const [defaultModalAction, setDefaultModalAction] = useState(() => null);
  const [modalItem, setDefaultModalItem] = useState({});
  const [onRequest, setOnRequest] = useState(true);
  const [isDisabled, setIsDisable] = useState(false);
  const [reminderShow, setReminderShow] = useState(false);
  const [reminderItem, setReminderItem] = useState({});

  const handleModalClose = () => {
    setModalShow(false);
    setDefaultModalShow(false);
    setDefaultModalTitle('');
    setDefaultModalBody('');
    setOnRequest(false);
  };

  const handleSuccessRequest = () => {
    switch (status) {
      case 'approved':
        dispatch(sendAlert({ kind: 'success', message: 'Solicitud aceptada correctamente' }));
        break;
      case 'rejected':
        dispatch(sendAlert({ kind: 'success', message: 'Solicitud rechazada correctamente' }));
        break;
      default:
        break;
    }
    setMoreData(!moreData);
    handleModalClose();
  };

  const handleApproveRequest = (otherRequest, setSubmitting) => {
    const { id: otherRequestId } = otherRequest.otherRequest;
    const myParams = snakeCaseKeys(otherRequest);

    approveOtherRequestRequest(otherRequestId, {
      dispatch,
      params: myParams,
      successCallback: () => handleSuccessRequest('approved'),
      failureCallback: error => {
        dispatch(sendAlert({ kind: 'error', message: error.response?.data?.message }));
        setMoreData(!moreData);
        setDefaultModalShow(false);
      },
      callback: () => setSubmitting(false)
    });
  };

  const handleApproveModal = otherRequest => {
    const reviewerSignature = otherRequest.requestReviewerSignature;

    setDefaultModalTitle(reviewerSignature ? 'Firmar Documento' : 'Aprobar Solicitud');
    setDefaultModalBody(
      <OtherRequestForm
        formRequest={handleApproveRequest}
        handleModalClose={() => setDefaultModalShow(false)}
        otherRequest={otherRequest}
        reviewerSignature={reviewerSignature}
        employee={currentEmployee}
        action="approve"
        rrhh
      />
    );
    setDefaultModalButtons(false);
    setDefaultModalShow(true);
  };

  const handleRejectRequest = otherRequest => {
    const { id: otherRequestId } = otherRequest.otherRequest;
    const myParams = snakeCaseKeys(otherRequest);

    rejectOtherRequestRequest(otherRequestId, {
      dispatch,
      params: myParams,
      formData: true,
      successCallback: () => handleSuccessRequest('rejected')
    });
  };

  const handleRejectModal = otherRequest => {
    setDefaultModalBody(
      <OtherRequestRejectForm
        formRequest={handleRejectRequest}
        handleModalClose={() => setDefaultModalShow(false)}
        otherRequest={otherRequest}
      />
    );
    setDefaultModalTitle('Rechazar solicitud');
    setDefaultModalButtons(false);
    setDefaultModalShow(true);
  };

  const handleSuccessRemove = () => {
    dispatch(sendAlert({ kind: 'success', message: 'Solicitud eliminada con éxito' }));
    setMoreData(!moreData);
  };

  const handleDeleteRequest = () => {
    setOnRequest(true);
    deleteOtherRequestRequest(item?.id, {
      dispatch,
      successCallback: handleSuccessRemove,
      callback: () => {
        setDefaultModalShow(false);
        setOnRequest(false);
      }
    });
  };

  const handleConfirmModal = () => {
    setIsDisable(false);
    setOnRequest(false);
    setDefaultModalShow(true);
    setDefaultModalItem(item);
    setDefaultModalBody('¿Estás seguro que deseas eliminar esta solicitud?');
    setDefaultModalTitle('Eliminar solicitud');
  };

  const handleActions = action => {
    switch (action) {
      case 'approved':
        handleApproveModal(camelCaseRecursive(item));
        break;
      case 'rejected':
        handleRejectModal(camelCaseRecursive(item));
        break;
      case 'resend':
        setReminderShow(true);
        setReminderItem(snakeCaseKeys(item));
        break;
      case 'destroy':
        handleConfirmModal(item);
        setDefaultModalAction(() => handleDeleteRequest);
        break;
      default:
        console.log('Error: Action not found');
        break;
    }
  };

  return (
    <>
      <Modal.Body>
        <div className="info-box">
          <Row>
            <Col md={2} lg={2}>
              <ApprovementStatusStyled margin="mt-1" status={status} />
            </Col>
            <Col md={8} lg={8} className="title-pw">
              <b>Gestionar Solicitud</b>
            </Col>
            <Col md={2} lg={2} className="title-pw" />
          </Row>
          <table className="simple-table">
            <tbody>
              <tr>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Solicita</th>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Fecha de Solicitud</th>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Tipo de Solicitud</th>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Fecha Desde</th>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Fecha Hasta</th>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Estado Solicitud</th>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Motivo</th>
                <th style={{ textAlign: 'center', paddingTop: '25px' }}>Adicional</th>
              </tr>
              <tr>
                <td style={{ width: '150px' }}>
                  <div bis_skin_checked="1" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <div aria-hidden="true" bis_skin_checked="1" className="employee-info" />
                    <span style={{ display: 'flex', justifyContent: 'center' }}>
                      <DatatableEmployeeName
                        item={item.employee}
                        fileName="fileInfo"
                        name="shortName"
                        fileUrl="fileUrl"
                      />
                    </span>
                  </div>
                </td>
                <td align="center">{createdAt}</td>
                <td align="center">{otherRequestTypeName}</td>
                <td align="center">{startDate}</td>
                <td align="center">{endDate || '--'}</td>
                <td align="center">{translatedStatus}</td>
                <td align="center">{reason || '--'}</td>
                <td align="center">{additional || '--'}</td>
              </tr>
            </tbody>
          </table>
          <br />

          <Row>
            <Col className="text-center">
              <ApproveRejectStyledActions
                resource="OtherRequest"
                item={item}
                clickHandler={handleActions}
                approveText={item.requestReviewerSignature ? 'Firmar / Aprobar' : 'Aprobar'}
                withDestroy
              />
            </Col>
          </Row>
        </div>
      </Modal.Body>
      <DefaultModal
        body={defaultModalBody}
        disabled={onRequest || isDisabled}
        handleClose={handleModalClose}
        handleConfirm={() => defaultModalAction(modalItem)}
        show={defaultModalShow}
        title={defaultModalTitle}
        titleBtnClose="Cancelar"
        titleBtnSave="Confirmar"
        withClose={defaultModalButtons}
        withConfirm={defaultModalButtons}
      />
      <Reminder
        item={reminderItem}
        show={reminderShow}
        modalShow={setReminderShow}
        moreData={moreData}
        setOnRequest={setOnRequest}
        setMoreData={setMoreData}
      />
    </>
  );
};

export default OtherRequestInfoTable;